var map = {
	"./bg.json": 3967,
	"./cnr.json": 1746,
	"./cs.json": 7312,
	"./cz_CZ.json": 8863,
	"./da.json": 4710,
	"./de.json": 424,
	"./en.json": 706,
	"./es.json": 6538,
	"./fi.json": 5226,
	"./fr.json": 2537,
	"./hu.json": 9606,
	"./it.json": 3634,
	"./nl.json": 4905,
	"./pl.json": 7753,
	"./pt.json": 8916,
	"./sv.json": 181,
	"./ta.json": 7512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4860;